import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Link } from "@edreamsodigeo/prisma-design-system";
const FormSwitcherLink = /*#__PURE__*/forwardRef(({
  label,
  onClick
}, ref) => /*#__PURE__*/React.createElement(Link, {
  size: "small",
  type: "primary",
  onClick: onClick,
  sx: {
    textDecoration: "none",
    textAlign: "center",
    display: "block",
    marginTop: "big",
    marginBottom: "3x_big"
  },
  ref: ref
}, label));
FormSwitcherLink.propTypes = {
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};
export default FormSwitcherLink;